module.exports = __webpack_public_path__ + "img/icon_so.21d7c91d.png";